import { render, staticRenderFns } from "./ViewSaleView.vue?vue&type=template&id=35a67053&scoped=true"
import script from "./ViewSaleView.vue?vue&type=script&lang=js"
export * from "./ViewSaleView.vue?vue&type=script&lang=js"
import style0 from "./ViewSaleView.vue?vue&type=style&index=0&id=35a67053&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a67053",
  null
  
)

export default component.exports